import React from 'react';
import { Route, Switch } from 'react-router-dom';
import './App.css';
import './design-system.css';

import Header from './Header';
import Nav from './Nav';
import Home from './Home';
import Terms from './Terms';
import Privacy from './Privacy';
import Cookie from './Cookie';
import OptOut from './OptOut';
import Tracking from './Tracking';
import Footer from './Footer';

function App() {
  
  return (
    <div className="App">
      <Header/>
      <Nav/>
      
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/terms" component={Terms} exact />
        <Route path="/privacy" component={Privacy} exact />
        <Route path="/cookie" component={Cookie} exact />
        <Route path="/opt-out" component={OptOut} exact />
        <Route component={Error} />
      </Switch>
      
      <Footer/>
      <Tracking/>
    </div>
  );
}

export default App;
